var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.248c7.044 0 12.754 5.71 12.754 12.753S23.044 28.754 16 28.754c-1.315 0-2.584-.2-3.776-.57.52-.847 1.297-2.235 1.585-3.342.155-.597.794-3.032.794-3.032.416.793 1.631 1.464 2.923 1.464 3.846 0 6.617-3.537 6.617-7.933 0-4.212-3.44-7.365-7.861-7.365-5.504 0-8.427 3.694-8.427 7.716 0 1.87.996 4.198 2.589 4.94.242.113.37.063.426-.17.042-.177.258-1.043.354-1.446a.382.382 0 00-.089-.366c-.527-.64-.95-1.814-.95-2.91 0-2.813 2.13-5.535 5.759-5.535 3.133 0 5.326 2.135 5.326 5.188 0 3.45-1.742 5.84-4.008 5.84-1.252 0-2.19-1.035-1.889-2.304.36-1.517 1.056-3.152 1.056-4.246 0-.98-.526-1.797-1.614-1.797-1.28 0-2.307 1.324-2.307 3.097 0 1.13.381 1.893.381 1.893s-1.263 5.345-1.495 6.34c-.256 1.101-.155 2.65-.043 3.659-4.745-1.859-8.106-6.473-8.106-11.876C3.246 8.956 8.956 3.246 16 3.246",
    fill: "#fff"
  })));
}

export default SvgPinterest;